// extracted by mini-css-extract-plugin
export default {"box":"arsenal_box__vmm-f"};